module.exports = __webpack_public_path__ + "img/flag.06d72c91.svg";